import { supabase } from './supabase';
import { Stage } from '../types/stage';

export const getStages = async (): Promise<Stage[]> => {
  const { data, error } = await supabase
    .from('stages')
    .select('*')
    .order('position', { ascending: true });
  if (error) { console.error('Error fetching stages:', error); return []; }
  return (data as Stage[]) || [];
};

export const createStage = async (name: string, position: number): Promise<Stage | null> => {
  const { data, error } = await supabase
    .from('stages')
    .insert({ name, position })
    .select()
    .single();
  if (error) { console.error('Error creating stage:', error); return null; }
  return data as Stage;
};

export const updateStage = async (id: string, updates: Partial<Pick<Stage, 'name' | 'position'>>): Promise<boolean> => {
  const { error } = await supabase.from('stages').update(updates).eq('id', id);
  if (error) { console.error('Error updating stage:', error); return false; }
  return true;
};

export const deleteStage = async (id: string): Promise<boolean> => {
  // Remove stage_id from leads first
  await supabase.from('leads').update({ stage_id: null }).eq('stage_id', id);
  const { error } = await supabase.from('stages').delete().eq('id', id);
  if (error) { console.error('Error deleting stage:', error); return false; }
  return true;
};

export const reorderStages = async (stages: Stage[]): Promise<boolean> => {
  const updates = stages.map((s, i) => supabase.from('stages').update({ position: i }).eq('id', s.id));
  await Promise.all(updates);
  return true;
};
